import { Controller } from "@hotwired/stimulus"
import { isTurboFrameVisit } from "../../utilities/is_turbo_frame_visit"
import { FetchRequest } from '@rails/request.js'

// send patch request to unlock record on leaving form without saving
export default class extends Controller {
  static values = {
    url: String,
  }

  unlock(e) {
    if (!e.defaultPrevented) {
      new FetchRequest('patch', this.urlValue, {
        redirect: "manual",
        keepalive: true,
      }).perform()
    }
  }

  onBeforeFetch(e) {
    if (isTurboFrameVisit(e)) this.unlock(e)
  }

  preventPrefetch() {
    // :prevent modifier on action
    // disabled not to prefetch lock state on bib_record (link in breadcrumb)
  }

}
